"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ECategorieSocialProfessionnelTrads = void 0;
exports.ECategorieSocialProfessionnelTrads = {
    agriculteur_exploitant: "Agriculteurs exploitants / Agricultrices exploitantes",
    artisan_commercant: "Artisans / Artisanes, commerçants / commerçantes et chefs / cheffes d'entreprise",
    cadre: "Cadres et professions intellectuelles supérieures",
    ouvrier: "Ouvriers / Ouvières",
    profession_intermediaire: "Professions intermédiaires",
    employe: "Employés / Employées",
    sans_activite: "Sans activité professionnelle",
    retraite: "Retraités / Retraitées",
    liberal: "Professions libérales",
};
